import { WebsocketHandler } from "./WebsocketHandler";
import store from "@/store/index";
import { debounce } from "@/assets/utils/unit";
import {getBudgetInfo, getPlanInfo} from "@/views/plan/js/function";
export const Websocket = {
  data() {
    return {
      lastNotificationTime: 0,
      lastNotificationTime1: 0,
      path: process.env.VUE_APP_WEBSOCKET + store.state.userInfor.userId,
      socket: "",
      heartbeatInterval: null, // 保存心跳定时器的ID
      heartbeatTimeout: 5000, // 心跳间隔时间
    };
  },
  mixins: [WebsocketHandler],
  mounted() {
    this.initSocket();
  },
  destroyed() {
    // 销毁监听
    this.close();
  },
  methods: {
    initSocket() {
      if (typeof WebSocket === "undefined") {
        alert("您的浏览器不支持socket");
      } else {
        // 实例化socket
        this.socket = new WebSocket(this.path);
        // 监听socket连接
        this.socket.onopen = this.open;
        // 监听socket错误信息
        this.socket.onerror = this.error;
        // 监听socket消息
        this.socket.onmessage = this.getMessage;

        this.socket.onclose = (event) => {
          if (event.type === "close") {
            console.log("短线重连");
            setTimeout(() => {
              this.initSocket();
            }, 5000);
          }
        };
      }
    },
    open() {
      console.log("socket连接成功");
      if (this.socket.readyState === 1) {
        // 发送用户token 更新状态
        this.send(
          {
            token: store.state.accessToken,
          },
          this.wSReqTypeEnum.SUCCESSFULLY_CONNECTED
        );
        // this.send({},this.wSReqTypeEnum.SUCCESSFULLY_ORDER_LIST_UNREAD)
        // 建立心跳定时器
        this.heartbeatInterval = setInterval(() => {
          this.send("ping", this.wSReqTypeEnum.HEARTBEAT);
        }, this.heartbeatTimeout);
      }
    },
    error() {
      console.log("连接错误");
    },
    // 发送消息给被连接的服务端
    send(params, reqTypeEnum) {
      let dataByCode = this.wSReqTypeEnum.setDataByCode(
        reqTypeEnum.code,
        params
      );
      let value = JSON.stringify(dataByCode);
      console.log("value", value);
      this.socket.send(value);
    },
    close() {
      console.log("socket已经关闭");
      // 清除心跳定时器
      clearInterval(this.heartbeatInterval);
    },
    debouncedOpenMsg: debounce(function (msg) {
      const notification = this.$notify({
        title: "提示",
        message: msg,
        dangerouslyUseHTMLString: true,
        duration: 10000,
        onClick: () => {
          this.$router.push({
            name: "myDeal",
            query: { currentComponent: "sonOrder" },
          });
          notification.close();
        },
      });
    }, 1000),
    getMessage(msg) {
      let parse = JSON.parse(msg.data);
      if (parse.data.content) {
        const contentBlocking = ["恭喜您下单成功,请尽快支付..."];
        if(this.$route.name === 'plan') {
            getBudgetInfo(store.state.budgetMainId, null)
            this.$Bus.$emit("paySuccess");
        }
        if (contentBlocking.findIndex((n) => n === parse.data.content) === -1) {
          this.$Bus.$emit("PAY_SUCCESS", parse.data);
        }
        this.debouncedOpenMsg(parse.data.content);
      }
    },
  },
};
